import {useMemo} from "react";

import type {MessageRule} from "../../../models/messageRule";
import {usePartner} from "../usePartner";

export function useWarningMessageForGuideUrlTag(value?: string | MessageRule["messages"]) {
    const touchstay = usePartner("touchstay");

    const warningMessage = useMemo(() => {
        const message =
            "You have selected the {{Guidebook URL}} tag but don't have a guidebook integration configured. Please check out our integrations page to see the guidebook integrations we support.";
        if (
            typeof value === "string" &&
            value.search("{{Guidebook URL}}") !== -1 &&
            !touchstay?.isConnected
        ) {
            return message;
        }
        if (typeof value === "object") {
            const hasGuidebookUrlTag = Object.values(value).some(
                message => typeof message === "string" && message.search("{{Guidebook URL}}") !== -1
            );

            if (hasGuidebookUrlTag && !touchstay?.isConnected) {
                return message;
            }
        }
        return undefined;
    }, [value, touchstay]);

    return warningMessage;
}
